import withAuth from "./withAuthProvider";
import toast from "react-hot-toast";

/**
 * Optimistically toggle favorite for a unit stored in redux.
 *
 * - dispatch optimistic state immediately
 * - call API
 * - on failure revert and show toast
 *
 * Params:
 * - {unit} current unit object
 * - {dispatch} redux dispatch
 * - {actionsUnit} actionsUnit from redux slice
 * - {images} current images array from redux
 */
export async function toggleUnitFavoriteOptimistic({ unit, dispatch, actionsUnit, images }) {
  if (!unit || !unit.id) return;

  const isCurrentlyFavorite = unit?.is_favorite !== "false";
  const prevUnit = { ...unit };

  const optimisticUnit = {
    ...unit,
    is_favorite: isCurrentlyFavorite ? "false" : "true",
    count_wishlist: isCurrentlyFavorite
      ? Math.max(parseInt(unit?.count_wishlist || 0) - 1, 0).toString()
      : (parseInt(unit?.count_wishlist || 0) + 1).toString(),
  };

  // apply optimistic update
  dispatch(actionsUnit.setUnit({ unit: optimisticUnit, images }));

  const loading = toast.loading("Mengirimkan...");
  try {
    if (isCurrentlyFavorite) {
      // send delete
      const response = await withAuth.deleteDataWithAuth(`/api/favorite/${unit.id}/delete`);
      if (response?.status === 200) {
        toast.dismiss(loading);
        toast.success(response.data.message, { id: "success-message", duration: 3000 });
        return { success: true, response };
      }
      throw new Error("Failed to delete");
    } else {
      // send add
      const response = await withAuth.postDataWithAuth("/api/favorite/add", { stock_unit_id: unit.id });
      if (response?.status === 200) {
        toast.dismiss(loading);
        toast.success(response.data.message, { id: "success-message", duration: 3000 });
        return { success: true, response };
      }
      throw new Error("Failed to add");
    }
  } catch (err) {
    // revert
    dispatch(actionsUnit.setUnit({ unit: prevUnit, images }));
    toast.dismiss(loading);
    toast.error("Terjadi kesalahan. Silakan coba lagi.", { id: "error-message" });
    return { success: false, error: err };
  }
}
